import axios, { AxiosRequestConfig } from 'axios'

import { apiEndpointWebBaseUrl } from '@environments/environment'

import { isJwtTokenExpired } from '@utils/jwt-token'

const includedAuthHeaderParts = [
  '/api/v1/CouponUser'
]

const shouldIncludesAuthToken = (url: string|undefined): boolean => {
  let result = false

  if (url && url.length)
    includedAuthHeaderParts.forEach(part => {
      if (url.startsWith(part)) result = true
    })

  return result
}

const axiosInstance = axios.create({
  baseURL: `${apiEndpointWebBaseUrl}`,
  timeout: 30000
})

axiosInstance.interceptors.response.use(
  response => response,
  error => {
    const { status } = error.response
    if (status === 401) {
      window.location.href = '/unauthorized'
    }

    return Promise.reject(error)
  }
)

/* eslint no-debugger: "off" */
/* eslint no-console: "off" */
axiosInstance.interceptors.request.use(
  async (config: AxiosRequestConfig) => {
    if (shouldIncludesAuthToken(config.url)) {
      let jwtToken: string = localStorage.getItem('jwtToken') || ''

      if (isJwtTokenExpired(jwtToken)) {
        try {
          const refreshTokenResponse: any = await axiosInstance.post('/api/v1/StoreUser/RefreshToken', null, {
            headers: {
              refreshToken: localStorage.getItem('refreshToken')
            }
          })
          jwtToken = refreshTokenResponse.data.jwtToken
          localStorage.setItem('jwtToken', jwtToken)
          if (refreshTokenResponse.data.refreshToken) {
            localStorage.setItem('refreshToken', refreshTokenResponse.data.refreshToken)
          }
        } catch (e) {
          window.location.replace('/login')
        }
      }

      if (jwtToken) {
        config.headers.Authorization = `Bearer ${jwtToken}`
      }
    }

    return config
  },
  (error: any) => {
    Promise.reject(error)
  }
)

export default axiosInstance
